<template>
    <div class="form-default-message">
        <mu-paper :z-depth="1">

            <mu-form :model="form">

                <mu-row gutter>
                    <mu-col span="12" sm="12" md="9" lg="9" xl="9">
                        <!-- Mensagem -->
                        <mu-text-field v-model="form.description" full-width label="Título *"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                        <!-- Code -->
                        <mu-text-field v-model="form.code" readonly full-width label="Código (Gerado Automaticamente)"></mu-text-field>
                    </mu-col>
                </mu-row>

                <mu-row gutter>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Mensagem -->
                        <mu-form-item prop="textarea" label="Mensagem *">
                            <mu-textarea-variable :message="form.message" v-on:sendMessage="getMessage"></mu-textarea-variable>
                        </mu-form-item>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <mu-form-item prop="textarea" label="Mensagem Final *">
                            <mu-text-field multi-line :rows="6" :rows-max="6" v-model="finalmessage" disabled></mu-text-field>
                        </mu-form-item>
                    </mu-col>
                </mu-row>

                <!-- Salvar -->
                <mu-flex class="actions">
                    <mu-button round color="primary" @click="saveForm()" :disabled="!form.message || !form.description">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Salvar
                    </mu-button>
                    <mu-button round :to="{ name: 'app.settings.messagedefault' }">
                        Cancelar
                    </mu-button>
                </mu-flex>

            </mu-form>

        </mu-paper>

        <br>

        <!-- Bloco para excluir o mensagem -->
        <mu-paper class="cancel" :z-depth="1" v-if="type == 'edit'">

            <!-- Pergunta para excluir o mensagem  -->
            <mu-row class="user-cost" justify-content="center" align-items="center">
                <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                    <mu-flex class="title" justify-content="start" align-items="center">
                        <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left color-red"/>
                        <strong>Excluir mensagem</strong>
                    </mu-flex>
                    A mensagem depois de excluída não terá como recuperar.
                </mu-col>
                <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                    <div class="text-right">
                        <mu-button round color="error" @click="handleDialogDelete(true)">
                            <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                            Excluir
                        </mu-button>
                    </div>
                </mu-col>
            </mu-row>

            <!-- Dialogo para confirmar exclusão de campanha -->
            <mu-dialog title="Excluir a mensagem" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openDelete">
                Tem certeza que deseja excluir a mensagem <strong>{{ form.description }}</strong>
                <mu-button slot="actions" round @click="handleDialogDelete(false)">Cancelar</mu-button>
                <mu-button slot="actions" round color="error" @click="deleteForm()">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Confirmar
                </mu-button>
            </mu-dialog>

        </mu-paper>

    </div>
</template>

<script>
    import DefaultMessageServices from '@/services/settings/message-default'

    export default {
        name: 'mu-form-default-message',
        props: ['type'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                message: '',
                form: {
                    description: '',
                    message: '',
                    finalmessage: ''
                },
                cancel: {
                    openDelete: false
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {
            finalmessage () {
                return this.strSlug(this.form.message || '')
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            if (this.type === 'edit') {
                this.loadForm()
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Habilita ou desabilita o dialogo para excluir a mensagem
             */
            handleDialogDelete (value) {
                this.cancel.openDelete = value
            },

            /**
             * É acionado quando um evento sendMessage for executado no <mu-textarea-variable>
             */
            getMessage (message) {
                this.message = message
                this.form.message = message
            },

            /**
             * Carrega os dados e adiciona no formulário
             */
            async loadForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando os dados da mensagem padrão.')

                    let result = await DefaultMessageServices.find(this.$route.params.id)

                    if (result && result.status) {
                        this.form = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados no formulário
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando a mensagem padrão.')

                    this.form.message = this.message || this.form.message
                    this.form.finalmessage = this.finalmessage

                    let result
                    if (this.type === 'edit') {
                        result = await DefaultMessageServices.update(this.form)
                    } else {
                        result = await DefaultMessageServices.store(this.form)
                    }

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.settings.messagedefault' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Responsável por excluir a mensagem padrão
             */
            async deleteForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde, a mensagem padrão está sendo excluída.')

                    let result = await DefaultMessageServices.destroy(this.form.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.settings.messagedefault' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível excluir o item.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .form-default-message
        margin 20px 0

        .actions
            .mu-button
                margin-right 5px

        .mu-paper
            padding 20px

        .cancel
            background lighten(#F44336, 92%)
            padding 20px
            color #999
            border 1px #F44336 dotted

            .title
                i
                    font-size 18px !important
                    color #F44336
                strong
                    font-size 16px
                    padding-left 5px
                    color #F44336

            .text-center
                text-align center

            .text-right
                text-align right
        .color-red
            color #f44336

</style>
